export const platformVersion = '^19.2.0';
